let pendingRestoreScrollY: number | null = null;

export function setPendingMobileFeedRestoreScrollY(scrollY: number): void {
  pendingRestoreScrollY = scrollY;
}

export function clearPendingMobileFeedRestoreScrollY(): void {
  pendingRestoreScrollY = null;
}

export function takePendingMobileFeedRestoreScrollY(): number | null {
  const scrollY = pendingRestoreScrollY;
  pendingRestoreScrollY = null;
  return scrollY;
}
